export default () => {

  const c = {}
  const init = () => {
    c.selects = document.querySelectorAll('.ct-custom-select');
    if (c.selects.length == 0) {
      return;
    }

    console.log('buildCustomSelect');

    bindSelectAction();
  }

  const bindSelectAction = () => {
    c.selects.forEach(select => {
      const targetLink = select.querySelector('.ct-custom-select__link');
      targetLink.addEventListener('click', (e) => {
        e.preventDefault();
        selectAction(select);
      })

      const options = select.querySelectorAll('.ct-custom-select__option');
      const selectBody = select.querySelector('.ct-custom-select__body');
      options.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          optionSelectAction(option.dataset, select, selectBody);
        })
      })

      const catId = select.querySelector('._id');
      select.getId = () => {
        return catId.value;
      }
      const catTxt = select.querySelector('._txt');
      select.getVal = () => {
        return catTxt.value;
      }

      // データが書き換わる際に外部から設定されたcallback関数を発火
      select.onchange = () => {
        // 外部からbindされたcallback関数
        if (select.changeAction) {
          select.changeAction();
        }
        console.log('onchange callback:', !!select.changeAction)
      }
    });
  }
  const selectAction = (selectEle) => {
    const selectBody = selectEle.querySelector('.ct-custom-select__body');
    if (selectEle.classList.contains('is-active')) {
      selectEle.classList.remove('is-active');
      closeBodyAction(selectBody)
    } else {
      selectEle.classList.add('is-active');
      openBodyAction(selectBody);
    }
  }
  const closeBodyAction = (selectBodyEle) => {
    selectBodyEle.removeAttribute('style');
  }
  const openBodyAction = (selectBodyEle) => {
    const childElement = selectBodyEle.firstElementChild;
    selectBodyEle.style.height = `${childElement.clientHeight}px`;
  }

  const optionSelectAction = (data, selectEle, selectBodyEle) => {
    const catId = selectEle.querySelector('._id');
    const catTxt = selectEle.querySelector('._txt');
    catId.value = data.id;
    catTxt.value = data.value;
    const targetTxt = selectEle.querySelector('.ct-custom-select__link-txt');
    targetTxt.textContent = data.value;

    selectEle.classList.remove('is-active');
    closeBodyAction(selectBodyEle);
    selectEle.onchange();
  }

  init();
}
